import React from 'react';
import HamburgerMenu from '../global/menu';
import { BRANDING } from '../config';
import '../global/styles.css';

const DEA_FORMS = [
  {
    id: 'station-1',
    name: 'Station 1 DEA Form 41',
    filename: 'dea-form-41-station-1.pdf'
  },
  {
    id: 'station-2',
    name: 'Station 2 DEA Form 41',
    filename: 'dea-form-41-station-2.pdf'
  }
];

function DEAForms({ userInfo, isAdmin, onLogout, onNavigate }) {
  const handleDownload = (filename, displayName) => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/forms/${filename}`;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--background-color)', padding: '20px' }}>
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div style={{ maxWidth: '600px', margin: '0 auto', paddingTop: '40px' }}>
        {/* Header */}
        <h1 style={{
          textAlign: 'center',
          color: 'var(--text-color)',
          fontSize: '28px',
          fontWeight: '600',
          marginBottom: '15px'
        }}>
          DEA Forms
        </h1>

        <p style={{
          textAlign: 'center',
          color: 'var(--text-muted)',
          fontSize: '16px',
          marginBottom: '40px'
        }}>
          Download DEA Form 41 for each station
        </p>

        {/* Form Cards */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {DEA_FORMS.map(form => (
            <div
              key={form.id}
              style={{
                background: 'var(--card-background)',
                border: '1px solid var(--border-color)',
                borderRadius: '12px',
                padding: '25px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
              }}
            >
              <div>
                <h3 style={{
                  color: 'var(--text-color)',
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: 0
                }}>
                  {form.name}
                </h3>
                <p style={{
                  color: 'var(--text-muted)',
                  fontSize: '14px',
                  margin: '5px 0 0 0'
                }}>
                  PDF Document
                </p>
              </div>
              <button
                onClick={() => handleDownload(form.filename, form.name)}
                className="btn btn-primary"
                style={{ padding: '10px 20px' }}
              >
                Download
              </button>
            </div>
          ))}
        </div>

        {/* Back Button */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <button
            onClick={() => onNavigate('home')}
            className="btn btn-secondary"
            style={{ padding: '12px 30px' }}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default DEAForms;
